import { useEffect, useMemo } from 'react';
import { useLocalStorageByUser } from 'common/hooks';
import {
  DEFAULT_VACATION_COLORS,
  GOOGLE_CALENDAR_VACATION_COLORS_KEY,
  VacationColors,
} from 'dashboard409a/common/constants/calendar';

let cachedVacationColors = DEFAULT_VACATION_COLORS;

export const getVacationColors = (): VacationColors => cachedVacationColors;

export const useVacationColors = () => {
  const [storedColors, setColors] = useLocalStorageByUser<VacationColors>(
    GOOGLE_CALENDAR_VACATION_COLORS_KEY,
    DEFAULT_VACATION_COLORS,
  );
  const colors = useMemo(
    () => ({ ...DEFAULT_VACATION_COLORS, ...storedColors }),
    [storedColors]
  );

  useEffect(() => {
    // Event renderers read this cache outside React hooks.
    cachedVacationColors = colors;
  }, [colors]);

  const handleChange = (key: keyof VacationColors, value: string) =>
    setColors(prev => ({ ...prev, [key]: value }));

  const handleReset = () => setColors(DEFAULT_VACATION_COLORS);

  return { colors, handleChange, handleReset };
};
